const LAYOUT_MENU_ITEM_IDS = {
  Dashboards: 1,
  MarketData: 2,
  News: 3
};
const LAYOUT_MENU_ITEMS = [
  // Dashboards - standard dropdown
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.Dashboards,
    title: {
      rendered: "Dashboards"
    },
    url: "#"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "market-explorer",
    title: {
      rendered: "Market Explorer"
    },
    url: "/research/market/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "housing-market-snapshot",
    title: {
      rendered: "Housing Market Snapshot"
    },
    url: "/research/monthly-snapshot/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "rent-trends",
    title: {
      rendered: "Rent Trends"
    },
    url: "/research/rent/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "new-construction",
    title: {
      rendered: "New Construction"
    },
    url: "/research/new-construction-data/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "market-heat-index",
    title: {
      rendered: "Market Heat Index"
    },
    url: "/research/market-heat-index/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "buy-vs-rent-breakeven",
    title: {
      rendered: "Buy vs. Rent Breakeven"
    },
    url: "/research/buy-vs-rent-breakeven/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "understanding-affordability",
    title: {
      rendered: "Understanding Affordability"
    },
    url: "/research/understanding-affordability/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "market-one-pager",
    title: {
      rendered: "Market One-Pager"
    },
    url: "/research/market-one-pager/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "search-trends",
    title: {
      rendered: "Search Trends"
    },
    url: "/research/home-shopping-search-trends/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "racial-disparities-housing",
    title: {
      rendered: "Racial Disparities in Housing"
    },
    url: "/research/racial-disparities-housing/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.Dashboards,
    id: "all-dashboards",
    title: {
      rendered: "All Dashboards"
    },
    url: "/research/dashboards/"
  },
  // Market Data - standard dropdown
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.MarketData,
    title: {
      rendered: "Market Data"
    },
    url: "#"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.MarketData,
    id: "housing-data-downloads",
    title: {
      rendered: "Housing Data (Downloads)"
    },
    url: "/research/data/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.MarketData,
    id: "zed",
    title: {
      rendered: "ZED"
    },
    url: "/research/zed/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.MarketData,
    id: "chartbook",
    title: {
      rendered: "Chartbook"
    },
    url: "/research/chartbook/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.MarketData,
    id: "ztrax",
    title: {
      rendered: "ZTRAX"
    },
    url: "/research/ztrax/"
  },
  {
    parent: LAYOUT_MENU_ITEM_IDS.MarketData,
    id: "all-market-data",
    title: {
      rendered: "All Market Data"
    },
    url: "/research/market-data/"
  },
  // News - direct link (outlinks to zillow.com/news)
  {
    parent: 0,
    id: LAYOUT_MENU_ITEM_IDS.News,
    title: {
      rendered: "News"
    },
    url: "/news/"
  }
];
const HEADER_CTAS = {
  primary: {
    label: "Press Inquiries",
    url: "mailto:press@zillow.com"
  },
  secondary: {
    label: "Subscribe",
    // Mirrors /news. Targets the WordPress footer block anchored `subscribe`;
    // /research/data renders it via getStaticProps.
    url: "#subscribe"
  }
};
const FOOTER_COLUMNS = [{
  title: "Research",
  description: "",
  links: [{
    title: "Housing Market",
    url: "/research/housing-market/"
  }, {
    title: "Rental Market",
    url: "/research/rental-market/"
  }, {
    title: "New Construction",
    url: "/research/new-construction/"
  }, {
    title: "Policy & Industry",
    url: "/research/policy-industry/"
  }, {
    title: "Macroeconomy",
    url: "/research/macroeconomy/"
  }, {
    title: "News",
    url: "/news/"
  }]
}, {
  title: "Dashboards",
  description: "",
  links: [{
    title: "All Dashboards",
    url: "/research/dashboards/"
  }, {
    title: "Market Explorer",
    url: "/research/market/"
  }, {
    title: "Housing Market Snapshot",
    url: "/research/monthly-snapshot/"
  }, {
    title: "Rent Trends",
    url: "/research/rent/"
  }, {
    title: "New Construction",
    url: "/research/new-construction-data/"
  }, {
    title: "Market Heat Index",
    url: "/research/market-heat-index/"
  }, {
    title: "Buy vs. Rent Breakeven",
    url: "/research/buy-vs-rent-breakeven/"
  }, {
    title: "Understanding Affordability",
    url: "/research/understanding-affordability/"
  }, {
    title: "Market One-Pager",
    url: "/research/market-one-pager/"
  }, {
    title: "Search Trends",
    url: "/research/home-shopping-search-trends/"
  }, {
    title: "Racial Disparities in Housing",
    url: "/research/racial-disparities-housing/"
  }]
}, {
  title: "Market Data",
  description: "",
  links: [{
    title: "All Market Data",
    url: "/research/market-data/"
  }, {
    title: "Housing Data (Downloads)",
    url: "/research/data/"
  }, {
    title: "ZED",
    url: "/research/zed/"
  }, {
    title: "ZTRAX",
    url: "/research/ztrax/"
  }, {
    title: "Chartbook",
    url: "/research/chartbook/"
  }, {
    title: "Methodology",
    url: "/research/methodology/"
  }, {
    title: "Data Release Calendar",
    url: "/research/calendar/"
  }]
}, {
  title: "About Us",
  description: "",
  links: [{
    title: "About Zillow's Research Team",
    url: "/research/about-us/"
  }, {
    title: "Subscribe",
    url: "/research/sign-up/"
  }, {
    title: "Contact Us",
    url: "/research/contact-us/"
  }]
}];
export {
  FOOTER_COLUMNS,
  HEADER_CTAS,
  LAYOUT_MENU_ITEMS,
  LAYOUT_MENU_ITEM_IDS
};
